export const makeFontStack = (fontFamily) => `"${fontFamily}", sans-serif`
